import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconCloseSmallCrop = (props) => /* @__PURE__ */ _jsx("svg", {
	fill: "none",
	viewBox: "0 0 48 48",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "m24 22.6 3.6-3.6 1.4 1.4-3.6 3.6 3.6 3.6-1.4 1.4-3.6-3.6-3.6 3.6-1.4-1.4 3.6-3.6-3.6-3.6 1.4-1.4 3.6 3.6z",
		clipRule: "evenodd",
		fill: "#111",
		fillRule: "evenodd"
	})
});
export default SvgIconCloseSmallCrop;
